export default __webpack_public_path__ + "static/media/bihorel4.71653070.jpg";